import Vue from "vue"
import SuiVue from "semantic-ui-vue"

export default Vue.use(SuiVue)
